module.exports = __webpack_public_path__ + "img/RO.607231b8.svg";